import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { ComponentService } from '../../services/component.service';

@Component({
  selector: 'app-imballi',
  templateUrl: './imballi.component.html',
  styleUrls: ['./imballi.component.css']
})
export class ImballiComponent implements OnInit {
  @ViewChild('nicaAnagraficaImballi', { static:false }) nicaAnagraficaImballi: NicaAnagraficaComponent;

  @Output() rowSelected = new EventEmitter<any>();
  @Input() itemData:any;
  constructor(public userComponentService: ComponentService) { }

  ngOnInit() {
  }
  emettiChiusuraCaption(e){
    
    this.userComponentService.destroyCurrentOpenPopUp('ImballiComponent')
    

  }

  optionalButton(e){
    console.log("Premuto Selezione ",e)
    if(e.name=='importa'){
      this.nicaAnagraficaImballi.selezionaRiga(e.row.key)
      e.data=e.row.data;
      this.nicaAnagraficaImballi.SelectionChanged(e)
    }
  }
  AllEvent(e:any){
    //
    if (e.name == "onSelectionChanged") {
      e.isSelected=true;
      this.rowSelected.emit(e);     
      console.log(e);
    }
  }
}
